// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bTournamentFormBlock {
  border: 1px solid #007bff;
  margin: 10px 0;
  padding: 10px;
}

.bTournamentFormCustomSectionBlock {
  border: 2px solid #007bff;
  margin: 10px 0;
  padding: 10px;
}

.bTournamentFormSectionButton {
  padding: 20px 0 40px 0;
}

.bVenueInput input::placeholder {
  font-size: 16px;
}

.bVenueInput:focus {
  outline: none;
}

.bFieldInvalid {
  border: 1px solid #dc3545 !important;
  border-radius: 0.25rem;
  padding: 4px;
}

.utCreateWizard {
  width: 100%;
  max-width: none;
  margin: 0 0 40px;
  color: #26374c;
}

.utCreateWizardPage {
  margin-top: 0 !important;
}

/* The union workspace owns a 24px/20px content gutter. The wizard header must
   escape it and sit directly below the application header, like list/detail headers. */
.bGenericView--union .bGenericContentColumn > .utCreateWizardPage {
  margin-top: -20px !important;
}

.utCreateWizard__context {
  display: flex;
  min-height: 58px;
  align-items: center;
  gap: 11px;
  box-sizing: border-box;
  width: calc(100% + 48px);
  margin: 0 0 16px -24px;
  padding: 14px 20px;
  border: 0;
  border-bottom: 1px solid #e2e8f0;
  border-radius: 0;
  background: #fff;
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);
}

.utCreateWizard__contextIcon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eaf4fb;
  color: #227ebd;
}

.utCreateWizard__contextIcon svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.utCreateWizard__contextCopy,
.utCreateWizard__contextCopy strong,
.utCreateWizard__contextCopy small {
  display: block;
  min-width: 0;
}

.utCreateWizard__contextCopy strong {
  overflow: hidden;
  color: #22344a;
  font-size: 13.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.utCreateWizard__contextCopy small {
  margin-top: 2px;
  overflow: hidden;
  color: #778699;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.utCreateWizard__contextSpacer {
  flex: 1;
}

.utCreateWizard__contextStatus,
.utCreateWizard__contextDirty,
.utCreateWizard__contextStep {
  flex: 0 0 auto;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 750;
}

.utCreateWizard__contextStatus {
  background: #eef2f6;
  color: #627287;
  text-transform: lowercase;
}

.utCreateWizard__contextStep {
  border: 1px solid #d7e8f4;
  background: #f4f9fd;
  color: #1a6da3;
}

.utCreateWizard__contextDirty {
  background: #fff5df;
  color: #9a681e;
}

.utCreateWizard__card {
  display: grid;
  grid-template-columns: 238px minmax(0, 1fr);
  overflow: visible;
  border: 1px solid #dbe4ec;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(31, 49, 70, 0.08);
}

.utCreateWizard__rail {
  padding: 24px 20px;
  border-right: 1px solid #e1e7ed;
  border-radius: 14px 0 0 14px;
  background: #f8fafc;
}

.utCreateWizard__railSteps {
  display: flex;
  flex-direction: column;
}

.utCreateWizard__railSteps button {
  position: relative;
  display: flex;
  min-height: 58px;
  align-items: flex-start;
  gap: 11px;
  width: 100%;
  padding: 0 0 20px;
  border: 0;
  background: transparent;
  color: #738196;
  text-align: left;
  cursor: pointer;
  appearance: none;
}

.utCreateWizard__railSteps button:not(:last-child)::after {
  position: absolute;
  z-index: 0;
  top: 30px;
  bottom: 0;
  left: 14px;
  width: 2px;
  background: #dbe4ec;
  content: '';
}

.utCreateWizard__railSteps button.is-done:not(:last-child)::after {
  background: #227ebd;
}

.utCreateWizard__railSteps button b {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  align-items: center;
  justify-content: center;
  border: 2px solid #cad5df;
  border-radius: 50%;
  background: #fff;
  font-size: 11px;
}

.utCreateWizard__railSteps button.is-active b,
.utCreateWizard__railSteps button.is-done b {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.utCreateWizard__railSteps button span,
.utCreateWizard__railSteps button strong,
.utCreateWizard__railSteps button small {
  display: block;
}

.utCreateWizard__railSteps button strong {
  padding-top: 2px;
  color: #465970;
  font-size: 12.5px;
}

.utCreateWizard__railSteps button.is-active strong {
  color: #176a9f;
}

.utCreateWizard__railSteps button small {
  margin-top: 2px;
  color: #8a97a8;
  font-size: 10.5px;
  line-height: 1.35;
}

.utCreateWizard__content {
  min-width: 0;
  padding: 22px 20px 0;
}

.utCreateWizard__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 18px;
}

.utCreateWizard__header span,
.utCreateWizard__sectionTitle > span {
  color: #227ebd;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.utCreateWizard__header h1 {
  margin: 2px 0 3px;
  color: #17263a;
  font-size: 25px;
  font-weight: 750;
}

.utCreateWizard__header p,
.utCreateWizard__sectionTitle p {
  margin: 0;
  color: #718096;
  font-size: 12.5px;
}

.utCreateWizard__header > button {
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #d7e0e9;
  border-radius: 9px;
  background: #fff;
  color: #66768a;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  appearance: none;
}

.utCreateWizard__steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: 16px;
  overflow: hidden;
  border: 1px solid #dfe6ed;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(31, 49, 70, 0.04);
}

.utCreateWizard__steps button {
  position: relative;
  display: flex;
  min-height: 70px;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 0;
  border-right: 1px solid #e6ebf0;
  background: #fff;
  color: #627287;
  text-align: left;
  cursor: pointer;
  appearance: none;
}

.utCreateWizard__steps button:last-child {
  border-right: 0;
}

.utCreateWizard__steps button:disabled {
  cursor: default;
  opacity: 0.72;
}

.utCreateWizard__steps button.is-active {
  background: #f1f8fd;
  color: #155f90;
}

.utCreateWizard__steps button.is-active::after {
  position: absolute;
  right: 12px;
  bottom: 0;
  left: 12px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: #227ebd;
  content: '';
}

.utCreateWizard__steps b {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd6e1;
  border-radius: 50%;
  background: #fff;
  font-size: 12px;
}

.utCreateWizard__steps .is-active b,
.utCreateWizard__steps .is-complete b {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.utCreateWizard__steps span,
.utCreateWizard__steps strong,
.utCreateWizard__steps small {
  display: block;
}

.utCreateWizard__steps strong {
  color: #2b3e55;
  font-size: 12.5px;
}

.utCreateWizard__steps small {
  margin-top: 2px;
  color: #8290a2;
  font-size: 10.5px;
  line-height: 1.25;
}

.utCreateWizard__content > .row {
  margin: 0;
}

.utCreateWizard__content > .row > .col-md-6 {
  max-width: 100%;
  flex: 0 0 100%;
  padding: 0;
}

.utCreateWizard__content > .row > .col-md-6 > .bTournamentFormBlock {
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0 !important;
  background: #fff;
  box-shadow: none;
}

.utCreateWizard .bTournamentFormBlock .bTournamentFormBlock {
  margin-top: 16px;
  padding: 16px;
  box-shadow: none;
}

.utCreateWizard__section.is-hidden,
.utCreateWizard .is-hidden {
  display: none !important;
}

.utCreateWizard__sectionTitle {
  display: flex;
  min-height: 38px;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8edf2;
}

.utCreateWizard__sectionTitle h2 {
  margin: 0;
  color: #1d2d42;
  font-size: 18px;
  font-weight: 750;
  white-space: nowrap;
}

.utCreateWizard__sectionTitle > span {
  flex: 0 0 auto;
  padding: 5px 8px;
  border-radius: 999px;
  background: #eaf4fb;
  white-space: nowrap;
}

.utCreateWizard__sectionTitle p {
  min-width: 0;
  margin-left: auto;
  text-align: right;
}

.utCreateWizard__review {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 20px;
}

.utCreateWizard__review > div {
  min-height: 88px;
  padding: 13px 14px;
  border: 1px solid #e0e7ee;
  border-radius: 9px;
  background: #f8fafc;
}

.utCreateWizard__review small,
.utCreateWizard__review strong,
.utCreateWizard__review span {
  display: block;
}

.utCreateWizard__review small {
  margin-bottom: 5px;
  color: #7a889a;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.utCreateWizard__review strong {
  overflow: hidden;
  color: #2a3b51;
  font-size: 12.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.utCreateWizard__review span {
  margin-top: 3px;
  overflow: hidden;
  color: #768598;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.utCreateWizard .form-group {
  margin-bottom: 17px;
}

.utCreateWizard .bTournamentViewLabel,
.utCreateWizard label {
  color: #34465c;
  font-size: 12px;
  font-weight: 700;
}

.utCreateWizard__required {
  margin-left: 2px;
  color: #d33b4d;
  font-weight: 800;
}

.utCreateWizard__chips {
  display: flex;
  min-height: 40px;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  padding: 4px;
  border: 1px solid transparent;
  border-radius: 9px;
}

.utCreateWizard__chips.is-invalid {
  border-color: #d33b4d;
  background: #fff8f8;
}

.utCreateWizard__chips button {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  gap: 6px;
  padding: 0 13px;
  border: 1px solid #d3dde7;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(35, 52, 72, 0.04);
  color: #465a70;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  appearance: none;
  transition: border-color 120ms ease, background 120ms ease, color 120ms ease, box-shadow 120ms ease;
}

.utCreateWizard__chips button:hover {
  border-color: #8ebbd8;
  background: #f5faff;
  color: #175f8e;
}

.utCreateWizard__chips button.is-selected {
  border-color: #227ebd;
  background: #227ebd;
  box-shadow: 0 2px 5px rgba(34, 126, 189, 0.2);
  color: #fff;
}

.utCreateWizard__chips button.is-selected::before {
  content: '✓';
  font-size: 11px;
  font-weight: 800;
}

.utCreateWizard__chipsHint {
  color: #8794a5;
  font-size: 12px;
}

.utCreateWizard .utCreateWizard__basicsSport {
  order: 1;
}

.utCreateWizard .utCreateWizard__basicsGender {
  order: 2;
}

.utCreateWizard .utCreateWizard__basicsAges {
  order: 3;
}

.utCreateWizard .utCreateWizard__basicsType {
  order: 4;
}

.utCreateWizard .utCreateWizard__basicsSubtype {
  order: 5;
}

.utCreateWizard .utCreateWizard__ageChips {
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  width: 100%;
}

.utCreateWizard .utCreateWizard__ageChips button {
  justify-content: center;
  min-width: 0;
  padding: 0 8px;
}

.utCreateWizard__ageHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  color: #34465c;
  font-size: 12px;
}

.utCreateWizard__ageHead > button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #227ebd;
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
}

.utCreateWizard__ageStages {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 4px;
  border: 1px solid transparent;
  border-radius: 10px;
}

.utCreateWizard__ageStages.is-invalid {
  border-color: #d33b4d;
  background: #fff8f8;
}

.utCreateWizard__ageStages > section {
  padding: 10px 11px;
  border: 1px solid #e0e7ee;
  border-radius: 9px;
  background: #f8fafc;
}

.utCreateWizard__ageStages > section > strong {
  display: block;
  margin-bottom: 7px;
  color: #65758a;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.035em;
  text-transform: uppercase;
}

.utCreateWizard__dateTimeFields {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(112px, 0.65fr);
  align-items: start;
  gap: 8px;
}

.utCreateWizard__dateTimeFields .sit-dp,
.utCreateWizard__dateTimeFields .sit-tp,
.utCreateWizard__dateTimeFields .sit-dp__trigger,
.utCreateWizard__dateTimeFields .sit-tp__trigger {
  width: 100%;
}

.utCreateWizard__dateTimePicker,
.utCreateWizard__dateTimePicker .sit-dp,
.utCreateWizard__dateTimePicker .sit-dp__trigger {
  width: 100%;
}

.utCreateWizard__venueCard {
  margin-top: 4px;
  padding: 17px 18px 18px;
  border: 1px solid #dce5ed;
  border-radius: 11px;
  background: #f8fafc;
}

.utCreateWizard__venueCard > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.utCreateWizard__venueCard h3 {
  margin: 0;
  color: #2a3c52;
  font-size: 13px;
  font-weight: 800;
}

.utCreateWizard__venueCard p {
  margin: 3px 0 0;
  color: #768598;
  font-size: 11.5px;
}

.utCreateWizard__venueCard > header button {
  display: inline-flex;
  height: 36px;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #b9d4e5;
  border-radius: 8px;
  background: #fff;
  color: #176a9f;
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
  appearance: none;
}

.utCreateWizard__venueCard > header button:hover {
  border-color: #7fb1d0;
  background: #f1f8fd;
}

.utCreateWizard__venueCard > header button.is-danger {
  border-color: #e4c2c7;
  color: #aa3545;
}

.utCreateWizard__venueCard > header button.is-danger:hover {
  border-color: #d99ca5;
  background: #fff5f6;
}

.utCreateWizard__venueCard > header svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.utCreateWizard__venueSearch input {
  min-height: 42px;
  border-color: #cbd7e2;
  border-radius: 8px;
  background: #fff;
}

.utCreateWizard__venueCard .bVenueInput {
  position: relative;
}

.utCreateWizard__venueCard .bVenueInput .dropdown-menu,
.utCreateWizard__venueCard .bVenueInput [class*='menu'] {
  z-index: 50;
}

.utCreateWizard .form-control {
  min-height: 40px;
  border: 1px solid #cfd9e4;
  border-radius: 8px;
  background: #fff;
  color: #24364c;
  font-size: 13px;
  box-shadow: none;
}

.utCreateWizard .form-control:focus {
  border-color: #5b9fce;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
}

.utCreateWizard .alert-danger,
.utCreateWizard .bFieldError,
.utCreateWizard .invalid-feedback {
  margin: 5px 0 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #b63849;
  font-size: 11.5px;
}

.utCreateWizard__footer {
  position: sticky;
  z-index: 20;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px -20px 0;
  padding: 12px 20px;
  border: 0;
  border-top: 1px solid #e2e8f0;
  border-radius: 0 0 12px 0;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 -8px 22px rgba(15, 23, 42, 0.055);
  backdrop-filter: blur(10px);
}

.utCreateWizard__footer > div:not(.utCreateWizard__footerContext) {
  display: flex;
  gap: 8px;
}

.utCreateWizard__footerContext {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 1px;
}

.utCreateWizard__footerContext span {
  color: #94a3b8;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.utCreateWizard__footerContext strong {
  overflow: hidden;
  color: #334155;
  font-size: 12.5px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.utCreateWizard__footer button {
  height: 38px;
  padding: 0 16px;
  border: 1px solid #ced8e2;
  border-radius: 8px;
  background: #fff;
  color: #45586e;
  font-size: 12.5px;
  font-weight: 750;
  cursor: pointer;
  appearance: none;
}

.utCreateWizard__footer button.is-cancel {
  border-color: transparent;
  background: transparent;
  color: #64748b;
}

.utCreateWizard__footer button.is-back {
  background: #f8fafc;
}

.utCreateWizard__footer button.is-primary {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
  box-shadow: 0 2px 5px rgba(34, 126, 189, 0.18);
}

.utCreateWizard__teamScoring {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.utCreateWizard__teamScoring label {
  display: flex;
  min-width: 0;
  margin: 0;
  flex-direction: column;
  gap: 6px;
}

.utCreateWizard__teamScoring label > span {
  overflow: hidden;
  color: #526579;
  font-size: 11px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.utCreateWizard__teamScoring input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #cfd9e3;
  border-radius: 8px;
  background: #fff;
  color: #20364d;
  font: inherit;
  font-weight: 700;
  text-align: center;
}

.utCreateWizard__teamScoring input:focus {
  border-color: #227ebd;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
  outline: none;
}

.utCreateWizard__teamScoring input.is-invalid {
  border-color: #d64545;
}

.utCreateWizard__scoringPreview {
  display: flex;
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #dce8f2;
  border-radius: 9px;
  background: #f5f9fc;
  color: #455b70;
  flex-wrap: wrap;
  gap: 5px 12px;
  font-size: 12.5px;
  line-height: 1.5;
}

.utCreateWizard__scoringPreview b {
  color: #1f405e;
}

.utCreateWizard__scoringPreview span {
  white-space: nowrap;
}

.utCreateWizard__scoringPreview small {
  width: 100%;
  color: #6b7e91;
}

.utCreateWizard__scoringSection {
  margin: 0 0 24px;
  padding: 20px;
  border: 1px solid #dfe7ef;
  border-radius: 14px;
  background: #fff;
}

.utCreateWizard__scoringSectionHeader {
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #edf2f7;
}

.utCreateWizard__scoringSectionHeader > span {
  display: block;
  margin-bottom: 4px;
  color: #718096;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.utCreateWizard__scoringSectionHeader h3 {
  margin: 0;
  color: #243b53;
  font-size: 18px;
  font-weight: 700;
}

.utCreateWizard__scoringSectionHeader p {
  max-width: 760px;
  margin: 5px 0 0;
  color: #62748a;
  font-size: 13px;
  line-height: 1.5;
}

.utCreateWizard__scoringSection .row {
  margin-bottom: -16px;
}

.utCreateWizard__teamScoreComposition {
  height: calc(100% - 16px);
  padding: 16px;
  border: 1px solid #e4eaf0;
  border-radius: 11px;
  background: #f8fafc;
}

.utCreateWizard__teamScoreTable {
  overflow: hidden;
  margin-top: 14px;
  border: 1px solid #dde5ed;
  border-radius: 9px;
  background: #fff;
}

.utCreateWizard__teamScoreTableHead,
.utCreateWizard__teamScoreTableRow {
  display: grid;
  grid-template-columns: minmax(92px, 1fr) 88px 88px;
  gap: 10px;
  align-items: center;
  padding: 9px 12px;
}

.utCreateWizard__teamScoreTableHead {
  color: #718096;
  background: #f4f7fa;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.utCreateWizard__teamScoreTableHead span:not(:first-child) {
  text-align: center;
}

.utCreateWizard__teamScoreTableRow + .utCreateWizard__teamScoreTableRow {
  border-top: 1px solid #edf2f7;
}

.utCreateWizard__teamScoreTableRow strong {
  color: #334e68;
  font-size: 13px;
}

.utCreateWizard__teamScoreTableRow .form-control {
  height: 38px;
  padding: 6px 8px;
  text-align: center;
}

@media (max-width: 575px) {
  .utCreateWizard__scoringSection {
    padding: 16px;
  }

  .utCreateWizard__teamScoreTableHead,
  .utCreateWizard__teamScoreTableRow {
    grid-template-columns: minmax(70px, 1fr) 72px 72px;
    gap: 7px;
    padding-right: 9px;
    padding-left: 9px;
  }
}

.utCreateWizard__netballRule {
  display: flex;
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #e1e7ed;
  border-radius: 9px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.utCreateWizard__netballRule > span {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.utCreateWizard__netballRule b {
  color: #263f57;
  font-size: 12.5px;
}

.utCreateWizard__netballRule small {
  color: #6b7e91;
  line-height: 1.4;
}

.utCreateWizard .sit-switch {
  min-height: 22px;
  margin: 0;
  padding: 0;
  align-items: center;
}

.utCreateWizard .sit-switch__track {
  box-sizing: border-box;
  margin: 0;
}

.utCreateWizard__settingRow {
  display: flex;
  margin-bottom: 16px;
  padding: 12px 14px;
  border: 1px solid #dde5ec;
  border-radius: 10px;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.utCreateWizard__settingRow > span {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.utCreateWizard__settingRow b {
  color: #263f57;
  font-size: 13px;
}

.utCreateWizard__settingRow small {
  color: #6b7e91;
  font-size: 12px;
  line-height: 1.45;
}

.utCreateWizard__compactField {
  max-width: 220px;
}

.utCreateWizard__fieldHelp {
  width: min(520px, calc(100vw - 48px));
  margin: -2px 0 8px;
  color: #6b7e91;
  font-size: 12px;
  line-height: 1.45;
}

.utCreateWizard__adminPickerRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 10px;
}

.utCreateWizard__clearAdmins {
  height: 40px;
  padding: 0 14px;
  border: 1px solid #cfd9e3;
  border-radius: 8px;
  background: #fff;
  color: #526579;
  font-size: 12.5px;
  font-weight: 700;
  white-space: nowrap;
}

.utCreateWizard__clearAdmins:hover {
  border-color: #b9c7d4;
  background: #f6f8fa;
  color: #253f57;
}

.utCreateWizard__coverUpload {
  width: 100%;
}

.utCreateWizard__coverGrid {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.utCreateWizard__coverGrid article {
  position: relative;
  overflow: hidden;
  border: 1px solid #d5e0e8;
  border-radius: 10px;
  background: #fff;
}

.utCreateWizard__coverGrid article > img {
  display: block;
  width: 100%;
  aspect-ratio: 3 / 1;
  object-fit: cover;
}

.utCreateWizard__coverGrid article > strong {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(23, 111, 167, 0.92);
  color: #fff;
  font-size: 9px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.utCreateWizard__coverGrid article footer {
  display: flex;
  padding: 7px 8px;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}

.utCreateWizard__coverGrid article footer button,
.utCreateWizard__cropModal footer button {
  height: 30px;
  margin: 0;
  padding: 0 9px;
  border: 1px solid #cbd7e1;
  border-radius: 7px;
  background: #fff;
  color: #395169;
  cursor: pointer;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
}

.utCreateWizard__coverGrid article footer button:disabled {
  opacity: 0.35;
  cursor: default;
}

.utCreateWizard__coverAdd {
  display: flex;
  min-height: 150px;
  margin: 0;
  border: 1px dashed #afc2d1;
  border-radius: 10px;
  background: #f7fafc;
  color: #277aaa;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2px;
  text-align: center;
}

.utCreateWizard__coverAdd > span {
  display: flex;
  width: 32px;
  height: 32px;
  margin-bottom: 3px;
  border-radius: 50%;
  background: #e5f2fa;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 400;
}

.utCreateWizard__coverAdd b {
  font-size: 12.5px;
}
.utCreateWizard__coverAdd small {
  color: #788a9b;
  font-size: 11px;
  font-weight: 400;
}

.utCreateWizard__coverUpload > p {
  margin: 9px 0 0;
  color: #718396;
  font-size: 11.5px;
  text-align: center;
}

.utCreateWizard__coverUpload input {
  display: none;
}

@media (max-width: 720px) {
  .utCreateWizard__coverGrid {
    grid-template-columns: 1fr;
  }
}

.utCreateWizard__cropModal img {
  max-height: 58vh;
}

.utCreateWizard__cropModal footer {
  display: flex;
  margin-top: 16px;
  justify-content: flex-end;
  gap: 9px;
}

.utCreateWizard__cropModal footer button {
  height: 38px;
  padding: 0 13px;
  font-size: 12.5px;
}

.utCreateWizard__cropModal footer button.is-primary {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.utCreateWizard__tagPicker {
  display: flex;
  padding: 4px 0;
  flex-wrap: wrap;
  gap: 8px;
}

.utCreateWizard__tagPicker button {
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid color-mix(in srgb, var(--tag-colour) 42%, #d7e0e8);
  border-radius: 999px;
  background: #fff;
  color: #496075;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.utCreateWizard__tagPicker button em {
  margin-left: 7px;
  padding: 2px 6px;
  border-radius: 999px;
  background: var(--tag-colour);
  color: #fff;
  font-size: 9px;
  font-style: normal;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.utCreateWizard__tagPicker button.is-selected {
  border-color: var(--tag-colour);
  background: color-mix(in srgb, var(--tag-colour) 12%, #fff);
  color: #20384e;
  box-shadow: inset 0 0 0 1px var(--tag-colour);
}

.utCreateWizard__createTag {
  min-height: 32px;
  margin-top: 8px;
  padding: 0 11px;
  border: 1px solid #cbd8e2;
  border-radius: 7px;
  background: #fff;
  color: #227ebd;
  font-size: 12px;
  font-weight: 750;
}

.utCreateWizard__tagModal {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.utCreateWizard__tagModal label {
  display: flex;
  margin: 0;
  color: #40566b;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
}
.utCreateWizard__tagModal input:not([type='color']),
.utCreateWizard__tagModal textarea {
  width: 100%;
  padding: 9px 10px;
  border: 1px solid #ccd7e1;
  border-radius: 8px;
  font: inherit;
}
.utCreateWizard__tagModal label.is-colour {
  width: 90px;
}
.utCreateWizard__tagModal input[type='color'] {
  width: 54px;
  height: 34px;
  padding: 2px;
  border: 1px solid #ccd7e1;
  border-radius: 7px;
  background: #fff;
}
.utCreateWizard__tagModal footer {
  display: flex;
  margin-top: 4px;
  justify-content: flex-end;
  gap: 8px;
}
.utCreateWizard__tagModal footer button {
  min-height: 36px;
  padding: 0 13px;
  border: 1px solid #ccd7e1;
  border-radius: 8px;
  background: #fff;
  color: #50657a;
  font-weight: 700;
}
.utCreateWizard__tagModal footer button.is-primary {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.utCreateWizard__addOptional {
  min-height: 38px;
  padding: 0 15px;
  border: 1px solid #227ebd;
  border-radius: 8px;
  background: #fff;
  color: #227ebd;
  font-size: 12.5px;
  font-weight: 750;
}

.utCreateWizard__optionalEmpty {
  margin-bottom: 14px;
  padding: 22px;
  border: 1px dashed #cad6e0;
  border-radius: 10px;
  background: #f8fafb;
  color: #75869a;
  text-align: center;
  font-size: 12.5px;
}

.utCreateWizard__optionalCard {
  display: flex;
  margin-bottom: 9px;
  padding: 11px 13px;
  border: 1px solid #dce4eb;
  border-radius: 9px;
  background: #fff;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.utCreateWizard__optionalCard > span {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.utCreateWizard__optionalCardPreview {
  display: flex;
  min-width: 0;
  min-height: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  color: inherit !important;
  flex: 1 1 auto;
  align-items: flex-start;
  flex-direction: column;
  text-align: left;
}

.utCreateWizard__optionalCard b {
  color: #294158;
  font-size: 13px;
}
.utCreateWizard__optionalCard small {
  overflow: hidden;
  color: #74869a;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.utCreateWizard__optionalCard > div {
  display: flex;
  gap: 5px;
}
.utCreateWizard__optionalCard button,
.utCreateWizard__optionalModalFooter button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #d1dbe4;
  border-radius: 7px;
  background: #fff;
  color: #52677b;
  font-size: 12px;
  font-weight: 700;
}
.utCreateWizard__optionalCard button:disabled {
  opacity: 0.35;
}

.utCreateWizard__optionalModalFooter {
  display: flex;
  margin-top: 16px;
  justify-content: flex-end;
  gap: 8px;
}

.utCreateWizard__optionalModalFooter button.is-primary {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.utCreateWizard__customSectionModal,
.utCreateWizard__customSectionModal .modal-content,
.utCreateWizard__customSectionModal .modal-body {
  max-height: none !important;
}

.utCreateWizard__customSectionModal .modal-body {
  overflow: visible !important;
}

.utCreateWizard__sectionPreview time {
  display: block;
  margin-bottom: 10px;
  color: #6c7f92;
  font-size: 12px;
  font-weight: 700;
}
.utCreateWizard__sectionPreview > img {
  width: 100%;
  max-height: 280px;
  margin-bottom: 14px;
  border-radius: 10px;
  object-fit: cover;
}
.utCreateWizard__sectionPreview > div {
  color: #334b61;
  line-height: 1.6;
}

.utCreateWizard__optionalSettings {
  max-width: 620px;
  margin: -7px 0 18px;
  padding: 14px;
  border: 1px solid #e0e7ed;
  border-radius: 10px;
  background: #f8fafb;
}

.utCreateWizard__optionalSettings .form-control,
.utCreateWizard__optionalSettings .mFullWidth {
  max-width: 360px;
}

@media (max-width: 1217px) {
  .bGenericView--union .bGenericContentColumn > .utCreateWizardPage {
    margin-top: -16px !important;
  }

  .utCreateWizard__context {
    width: 100vw;
    margin-left: -12px;
    padding-right: 16px;
    padding-left: 16px;
  }
}

@media (max-width: 760px) {
  .utCreateWizard {
    width: 100%;
    margin-top: 0;
  }

  .utCreateWizard__steps {
    grid-template-columns: 1fr 1fr;
  }

  .utCreateWizard__steps button:nth-child(2) {
    border-right: 0;
  }

  .utCreateWizard__steps button:nth-child(-n + 2) {
    border-bottom: 1px solid #e6ebf0;
  }

  .utCreateWizard .bTournamentFormBlock {
    padding: 17px 15px;
  }

  .utCreateWizard__contextStatus,
  .utCreateWizard__contextDirty,
  .utCreateWizard__contextStep {
    display: none;
  }

  .utCreateWizard__card {
    grid-template-columns: 1fr;
  }

  .utCreateWizard__rail {
    overflow-x: auto;
    padding: 12px;
    border-right: 0;
    border-bottom: 1px solid #e1e7ed;
    border-radius: 14px 14px 0 0;
  }

  .utCreateWizard__railSteps {
    width: max-content;
    flex-direction: row;
    gap: 15px;
  }

  .utCreateWizard__railSteps button {
    width: 160px;
    min-height: 42px;
    padding: 0;
  }

  .utCreateWizard__railSteps button::after {
    display: none;
  }

  .utCreateWizard__content {
    padding: 17px 15px 0;
  }

  .utCreateWizard__footer {
    margin-right: -15px;
    margin-left: -15px;
    padding-right: 15px;
    padding-left: 15px;
    border-radius: 0 0 12px 12px;
  }

  .utCreateWizard__footerContext {
    display: none;
  }

  .utCreateWizard__sectionTitle {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 6px 9px;
  }

  .utCreateWizard__sectionTitle h2 {
    white-space: normal;
  }

  .utCreateWizard__sectionTitle p {
    width: 100%;
    margin-left: 0;
    text-align: left;
  }

  .utCreateWizard__review {
    grid-template-columns: 1fr;
  }

  .utCreateWizard__dateTimeFields {
    grid-template-columns: 1fr;
  }

  .utCreateWizard__teamScoring {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .utCreateWizard .utCreateWizard__ageChips {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .utCreateWizard__ageStages {
    grid-template-columns: 1fr;
  }

  .utCreateWizard__venueCard > header {
    align-items: stretch;
    flex-direction: column;
  }

  .utCreateWizard__venueCard > header button {
    justify-content: center;
  }
}
.bTournamentSportMode {
  display: inline-flex;
  margin: 0 0 10px;
  padding: 3px;
  border: 1px solid #d9e4ec;
  border-radius: 999px;
  background: #f4f8fb;
}

.bTournamentSportMode button {
  min-height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #5f7182;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.bTournamentSportMode button.active {
  background: #fff;
  color: #1797b2;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.utCreateWizard__participantLimits {
  display: grid;
  gap: 14px;
  margin: 6px 0 18px;
  padding: 16px;
  border: 1px solid #dce6ee;
  border-radius: 12px;
  background: #f8fbfd;
}

.utCreateWizard__participantLimitsHeader strong,
.utCreateWizard__participantLimitsHeader small {
  display: block;
}

.utCreateWizard__participantLimitsHeader strong {
  color: #1e2d41;
  font-size: 14px;
  font-weight: 750;
}

.utCreateWizard__participantLimitsHeader small {
  margin-top: 3px;
  color: #748195;
  font-size: 12px;
  line-height: 1.45;
}

.utCreateWizard__participantLimits .utCreateWizard__settingRow {
  margin: 0;
  padding: 12px 0;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

.utCreateWizard__participantLimitGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.utCreateWizard__participantLimitGrid .form-group {
  margin: 0;
}

@media (max-width: 760px) {
  .utCreateWizard__participantLimitGrid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminSUView/Tournaments/TournamentForm/TournamentView.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;uFACuF;AACvF;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,4CAA4C;EAC5C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mGAAmG;AACrG;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;;EAGE,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,6BAA6B;EAC7B,yBAAyB;EACzB,qCAAqC;EACrC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kDAAkD;EAClD,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,kDAAkD;IAClD,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oEAAoE;EACpE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2DAA2D;EAC3D,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gCAAgC;IAChC,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".bTournamentFormBlock {\n  border: 1px solid #007bff;\n  margin: 10px 0;\n  padding: 10px;\n}\n\n.bTournamentFormCustomSectionBlock {\n  border: 2px solid #007bff;\n  margin: 10px 0;\n  padding: 10px;\n}\n\n.bTournamentFormSectionButton {\n  padding: 20px 0 40px 0;\n}\n\n.bVenueInput input::placeholder {\n  font-size: 16px;\n}\n\n.bVenueInput:focus {\n  outline: none;\n}\n\n.bFieldInvalid {\n  border: 1px solid #dc3545 !important;\n  border-radius: 0.25rem;\n  padding: 4px;\n}\n\n.utCreateWizard {\n  width: 100%;\n  max-width: none;\n  margin: 0 0 40px;\n  color: #26374c;\n}\n\n.utCreateWizardPage {\n  margin-top: 0 !important;\n}\n\n/* The union workspace owns a 24px/20px content gutter. The wizard header must\n   escape it and sit directly below the application header, like list/detail headers. */\n.bGenericView--union .bGenericContentColumn > .utCreateWizardPage {\n  margin-top: -20px !important;\n}\n\n.utCreateWizard__context {\n  display: flex;\n  min-height: 58px;\n  align-items: center;\n  gap: 11px;\n  box-sizing: border-box;\n  width: calc(100% + 48px);\n  margin: 0 0 16px -24px;\n  padding: 14px 20px;\n  border: 0;\n  border-bottom: 1px solid #e2e8f0;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.05);\n}\n\n.utCreateWizard__contextIcon {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: #eaf4fb;\n  color: #227ebd;\n}\n\n.utCreateWizard__contextIcon svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.utCreateWizard__contextCopy,\n.utCreateWizard__contextCopy strong,\n.utCreateWizard__contextCopy small {\n  display: block;\n  min-width: 0;\n}\n\n.utCreateWizard__contextCopy strong {\n  overflow: hidden;\n  color: #22344a;\n  font-size: 13.5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.utCreateWizard__contextCopy small {\n  margin-top: 2px;\n  overflow: hidden;\n  color: #778699;\n  font-size: 11px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.utCreateWizard__contextSpacer {\n  flex: 1;\n}\n\n.utCreateWizard__contextStatus,\n.utCreateWizard__contextDirty,\n.utCreateWizard__contextStep {\n  flex: 0 0 auto;\n  padding: 5px 9px;\n  border-radius: 999px;\n  font-size: 10.5px;\n  font-weight: 750;\n}\n\n.utCreateWizard__contextStatus {\n  background: #eef2f6;\n  color: #627287;\n  text-transform: lowercase;\n}\n\n.utCreateWizard__contextStep {\n  border: 1px solid #d7e8f4;\n  background: #f4f9fd;\n  color: #1a6da3;\n}\n\n.utCreateWizard__contextDirty {\n  background: #fff5df;\n  color: #9a681e;\n}\n\n.utCreateWizard__card {\n  display: grid;\n  grid-template-columns: 238px minmax(0, 1fr);\n  overflow: visible;\n  border: 1px solid #dbe4ec;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 12px 32px rgba(31, 49, 70, 0.08);\n}\n\n.utCreateWizard__rail {\n  padding: 24px 20px;\n  border-right: 1px solid #e1e7ed;\n  border-radius: 14px 0 0 14px;\n  background: #f8fafc;\n}\n\n.utCreateWizard__railSteps {\n  display: flex;\n  flex-direction: column;\n}\n\n.utCreateWizard__railSteps button {\n  position: relative;\n  display: flex;\n  min-height: 58px;\n  align-items: flex-start;\n  gap: 11px;\n  width: 100%;\n  padding: 0 0 20px;\n  border: 0;\n  background: transparent;\n  color: #738196;\n  text-align: left;\n  cursor: pointer;\n  appearance: none;\n}\n\n.utCreateWizard__railSteps button:not(:last-child)::after {\n  position: absolute;\n  z-index: 0;\n  top: 30px;\n  bottom: 0;\n  left: 14px;\n  width: 2px;\n  background: #dbe4ec;\n  content: '';\n}\n\n.utCreateWizard__railSteps button.is-done:not(:last-child)::after {\n  background: #227ebd;\n}\n\n.utCreateWizard__railSteps button b {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  flex: 0 0 30px;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #cad5df;\n  border-radius: 50%;\n  background: #fff;\n  font-size: 11px;\n}\n\n.utCreateWizard__railSteps button.is-active b,\n.utCreateWizard__railSteps button.is-done b {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.utCreateWizard__railSteps button span,\n.utCreateWizard__railSteps button strong,\n.utCreateWizard__railSteps button small {\n  display: block;\n}\n\n.utCreateWizard__railSteps button strong {\n  padding-top: 2px;\n  color: #465970;\n  font-size: 12.5px;\n}\n\n.utCreateWizard__railSteps button.is-active strong {\n  color: #176a9f;\n}\n\n.utCreateWizard__railSteps button small {\n  margin-top: 2px;\n  color: #8a97a8;\n  font-size: 10.5px;\n  line-height: 1.35;\n}\n\n.utCreateWizard__content {\n  min-width: 0;\n  padding: 22px 20px 0;\n}\n\n.utCreateWizard__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n\n.utCreateWizard__header span,\n.utCreateWizard__sectionTitle > span {\n  color: #227ebd;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.utCreateWizard__header h1 {\n  margin: 2px 0 3px;\n  color: #17263a;\n  font-size: 25px;\n  font-weight: 750;\n}\n\n.utCreateWizard__header p,\n.utCreateWizard__sectionTitle p {\n  margin: 0;\n  color: #718096;\n  font-size: 12.5px;\n}\n\n.utCreateWizard__header > button {\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 1px solid #d7e0e9;\n  border-radius: 9px;\n  background: #fff;\n  color: #66768a;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  appearance: none;\n}\n\n.utCreateWizard__steps {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  margin-bottom: 16px;\n  overflow: hidden;\n  border: 1px solid #dfe6ed;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 4px 16px rgba(31, 49, 70, 0.04);\n}\n\n.utCreateWizard__steps button {\n  position: relative;\n  display: flex;\n  min-height: 70px;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border: 0;\n  border-right: 1px solid #e6ebf0;\n  background: #fff;\n  color: #627287;\n  text-align: left;\n  cursor: pointer;\n  appearance: none;\n}\n\n.utCreateWizard__steps button:last-child {\n  border-right: 0;\n}\n\n.utCreateWizard__steps button:disabled {\n  cursor: default;\n  opacity: 0.72;\n}\n\n.utCreateWizard__steps button.is-active {\n  background: #f1f8fd;\n  color: #155f90;\n}\n\n.utCreateWizard__steps button.is-active::after {\n  position: absolute;\n  right: 12px;\n  bottom: 0;\n  left: 12px;\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: #227ebd;\n  content: '';\n}\n\n.utCreateWizard__steps b {\n  display: inline-flex;\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #cbd6e1;\n  border-radius: 50%;\n  background: #fff;\n  font-size: 12px;\n}\n\n.utCreateWizard__steps .is-active b,\n.utCreateWizard__steps .is-complete b {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.utCreateWizard__steps span,\n.utCreateWizard__steps strong,\n.utCreateWizard__steps small {\n  display: block;\n}\n\n.utCreateWizard__steps strong {\n  color: #2b3e55;\n  font-size: 12.5px;\n}\n\n.utCreateWizard__steps small {\n  margin-top: 2px;\n  color: #8290a2;\n  font-size: 10.5px;\n  line-height: 1.25;\n}\n\n.utCreateWizard__content > .row {\n  margin: 0;\n}\n\n.utCreateWizard__content > .row > .col-md-6 {\n  max-width: 100%;\n  flex: 0 0 100%;\n  padding: 0;\n}\n\n.utCreateWizard__content > .row > .col-md-6 > .bTournamentFormBlock {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0 !important;\n  background: #fff;\n  box-shadow: none;\n}\n\n.utCreateWizard .bTournamentFormBlock .bTournamentFormBlock {\n  margin-top: 16px;\n  padding: 16px;\n  box-shadow: none;\n}\n\n.utCreateWizard__section.is-hidden,\n.utCreateWizard .is-hidden {\n  display: none !important;\n}\n\n.utCreateWizard__sectionTitle {\n  display: flex;\n  min-height: 38px;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e8edf2;\n}\n\n.utCreateWizard__sectionTitle h2 {\n  margin: 0;\n  color: #1d2d42;\n  font-size: 18px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.utCreateWizard__sectionTitle > span {\n  flex: 0 0 auto;\n  padding: 5px 8px;\n  border-radius: 999px;\n  background: #eaf4fb;\n  white-space: nowrap;\n}\n\n.utCreateWizard__sectionTitle p {\n  min-width: 0;\n  margin-left: auto;\n  text-align: right;\n}\n\n.utCreateWizard__review {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.utCreateWizard__review > div {\n  min-height: 88px;\n  padding: 13px 14px;\n  border: 1px solid #e0e7ee;\n  border-radius: 9px;\n  background: #f8fafc;\n}\n\n.utCreateWizard__review small,\n.utCreateWizard__review strong,\n.utCreateWizard__review span {\n  display: block;\n}\n\n.utCreateWizard__review small {\n  margin-bottom: 5px;\n  color: #7a889a;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.utCreateWizard__review strong {\n  overflow: hidden;\n  color: #2a3b51;\n  font-size: 12.5px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.utCreateWizard__review span {\n  margin-top: 3px;\n  overflow: hidden;\n  color: #768598;\n  font-size: 11px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.utCreateWizard .form-group {\n  margin-bottom: 17px;\n}\n\n.utCreateWizard .bTournamentViewLabel,\n.utCreateWizard label {\n  color: #34465c;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.utCreateWizard__required {\n  margin-left: 2px;\n  color: #d33b4d;\n  font-weight: 800;\n}\n\n.utCreateWizard__chips {\n  display: flex;\n  min-height: 40px;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 7px;\n  padding: 4px;\n  border: 1px solid transparent;\n  border-radius: 9px;\n}\n\n.utCreateWizard__chips.is-invalid {\n  border-color: #d33b4d;\n  background: #fff8f8;\n}\n\n.utCreateWizard__chips button {\n  display: inline-flex;\n  min-height: 34px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 13px;\n  border: 1px solid #d3dde7;\n  border-radius: 999px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(35, 52, 72, 0.04);\n  color: #465a70;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  appearance: none;\n  transition: border-color 120ms ease, background 120ms ease, color 120ms ease, box-shadow 120ms ease;\n}\n\n.utCreateWizard__chips button:hover {\n  border-color: #8ebbd8;\n  background: #f5faff;\n  color: #175f8e;\n}\n\n.utCreateWizard__chips button.is-selected {\n  border-color: #227ebd;\n  background: #227ebd;\n  box-shadow: 0 2px 5px rgba(34, 126, 189, 0.2);\n  color: #fff;\n}\n\n.utCreateWizard__chips button.is-selected::before {\n  content: '✓';\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.utCreateWizard__chipsHint {\n  color: #8794a5;\n  font-size: 12px;\n}\n\n.utCreateWizard .utCreateWizard__basicsSport {\n  order: 1;\n}\n\n.utCreateWizard .utCreateWizard__basicsGender {\n  order: 2;\n}\n\n.utCreateWizard .utCreateWizard__basicsAges {\n  order: 3;\n}\n\n.utCreateWizard .utCreateWizard__basicsType {\n  order: 4;\n}\n\n.utCreateWizard .utCreateWizard__basicsSubtype {\n  order: 5;\n}\n\n.utCreateWizard .utCreateWizard__ageChips {\n  display: grid;\n  grid-template-columns: repeat(9, minmax(0, 1fr));\n  width: 100%;\n}\n\n.utCreateWizard .utCreateWizard__ageChips button {\n  justify-content: center;\n  min-width: 0;\n  padding: 0 8px;\n}\n\n.utCreateWizard__ageHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  color: #34465c;\n  font-size: 12px;\n}\n\n.utCreateWizard__ageHead > button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #227ebd;\n  font-size: 11.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.utCreateWizard__ageStages {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  padding: 4px;\n  border: 1px solid transparent;\n  border-radius: 10px;\n}\n\n.utCreateWizard__ageStages.is-invalid {\n  border-color: #d33b4d;\n  background: #fff8f8;\n}\n\n.utCreateWizard__ageStages > section {\n  padding: 10px 11px;\n  border: 1px solid #e0e7ee;\n  border-radius: 9px;\n  background: #f8fafc;\n}\n\n.utCreateWizard__ageStages > section > strong {\n  display: block;\n  margin-bottom: 7px;\n  color: #65758a;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.035em;\n  text-transform: uppercase;\n}\n\n.utCreateWizard__dateTimeFields {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(112px, 0.65fr);\n  align-items: start;\n  gap: 8px;\n}\n\n.utCreateWizard__dateTimeFields .sit-dp,\n.utCreateWizard__dateTimeFields .sit-tp,\n.utCreateWizard__dateTimeFields .sit-dp__trigger,\n.utCreateWizard__dateTimeFields .sit-tp__trigger {\n  width: 100%;\n}\n\n.utCreateWizard__dateTimePicker,\n.utCreateWizard__dateTimePicker .sit-dp,\n.utCreateWizard__dateTimePicker .sit-dp__trigger {\n  width: 100%;\n}\n\n.utCreateWizard__venueCard {\n  margin-top: 4px;\n  padding: 17px 18px 18px;\n  border: 1px solid #dce5ed;\n  border-radius: 11px;\n  background: #f8fafc;\n}\n\n.utCreateWizard__venueCard > header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.utCreateWizard__venueCard h3 {\n  margin: 0;\n  color: #2a3c52;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.utCreateWizard__venueCard p {\n  margin: 3px 0 0;\n  color: #768598;\n  font-size: 11.5px;\n}\n\n.utCreateWizard__venueCard > header button {\n  display: inline-flex;\n  height: 36px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 7px;\n  padding: 0 12px;\n  border: 1px solid #b9d4e5;\n  border-radius: 8px;\n  background: #fff;\n  color: #176a9f;\n  font-size: 12px;\n  font-weight: 750;\n  cursor: pointer;\n  appearance: none;\n}\n\n.utCreateWizard__venueCard > header button:hover {\n  border-color: #7fb1d0;\n  background: #f1f8fd;\n}\n\n.utCreateWizard__venueCard > header button.is-danger {\n  border-color: #e4c2c7;\n  color: #aa3545;\n}\n\n.utCreateWizard__venueCard > header button.is-danger:hover {\n  border-color: #d99ca5;\n  background: #fff5f6;\n}\n\n.utCreateWizard__venueCard > header svg {\n  width: 15px;\n  height: 15px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.utCreateWizard__venueSearch input {\n  min-height: 42px;\n  border-color: #cbd7e2;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.utCreateWizard__venueCard .bVenueInput {\n  position: relative;\n}\n\n.utCreateWizard__venueCard .bVenueInput .dropdown-menu,\n.utCreateWizard__venueCard .bVenueInput [class*='menu'] {\n  z-index: 50;\n}\n\n.utCreateWizard .form-control {\n  min-height: 40px;\n  border: 1px solid #cfd9e4;\n  border-radius: 8px;\n  background: #fff;\n  color: #24364c;\n  font-size: 13px;\n  box-shadow: none;\n}\n\n.utCreateWizard .form-control:focus {\n  border-color: #5b9fce;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n}\n\n.utCreateWizard .alert-danger,\n.utCreateWizard .bFieldError,\n.utCreateWizard .invalid-feedback {\n  margin: 5px 0 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #b63849;\n  font-size: 11.5px;\n}\n\n.utCreateWizard__footer {\n  position: sticky;\n  z-index: 20;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 20px -20px 0;\n  padding: 12px 20px;\n  border: 0;\n  border-top: 1px solid #e2e8f0;\n  border-radius: 0 0 12px 0;\n  background: rgba(255, 255, 255, 0.98);\n  box-shadow: 0 -8px 22px rgba(15, 23, 42, 0.055);\n  backdrop-filter: blur(10px);\n}\n\n.utCreateWizard__footer > div:not(.utCreateWizard__footerContext) {\n  display: flex;\n  gap: 8px;\n}\n\n.utCreateWizard__footerContext {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.utCreateWizard__footerContext span {\n  color: #94a3b8;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.utCreateWizard__footerContext strong {\n  overflow: hidden;\n  color: #334155;\n  font-size: 12.5px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.utCreateWizard__footer button {\n  height: 38px;\n  padding: 0 16px;\n  border: 1px solid #ced8e2;\n  border-radius: 8px;\n  background: #fff;\n  color: #45586e;\n  font-size: 12.5px;\n  font-weight: 750;\n  cursor: pointer;\n  appearance: none;\n}\n\n.utCreateWizard__footer button.is-cancel {\n  border-color: transparent;\n  background: transparent;\n  color: #64748b;\n}\n\n.utCreateWizard__footer button.is-back {\n  background: #f8fafc;\n}\n\n.utCreateWizard__footer button.is-primary {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n  box-shadow: 0 2px 5px rgba(34, 126, 189, 0.18);\n}\n\n.utCreateWizard__teamScoring {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.utCreateWizard__teamScoring label {\n  display: flex;\n  min-width: 0;\n  margin: 0;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.utCreateWizard__teamScoring label > span {\n  overflow: hidden;\n  color: #526579;\n  font-size: 11px;\n  font-weight: 750;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.utCreateWizard__teamScoring input {\n  width: 100%;\n  height: 40px;\n  padding: 0 10px;\n  border: 1px solid #cfd9e3;\n  border-radius: 8px;\n  background: #fff;\n  color: #20364d;\n  font: inherit;\n  font-weight: 700;\n  text-align: center;\n}\n\n.utCreateWizard__teamScoring input:focus {\n  border-color: #227ebd;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n  outline: none;\n}\n\n.utCreateWizard__teamScoring input.is-invalid {\n  border-color: #d64545;\n}\n\n.utCreateWizard__scoringPreview {\n  display: flex;\n  margin-top: 10px;\n  padding: 10px 12px;\n  border: 1px solid #dce8f2;\n  border-radius: 9px;\n  background: #f5f9fc;\n  color: #455b70;\n  flex-wrap: wrap;\n  gap: 5px 12px;\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.utCreateWizard__scoringPreview b {\n  color: #1f405e;\n}\n\n.utCreateWizard__scoringPreview span {\n  white-space: nowrap;\n}\n\n.utCreateWizard__scoringPreview small {\n  width: 100%;\n  color: #6b7e91;\n}\n\n.utCreateWizard__scoringSection {\n  margin: 0 0 24px;\n  padding: 20px;\n  border: 1px solid #dfe7ef;\n  border-radius: 14px;\n  background: #fff;\n}\n\n.utCreateWizard__scoringSectionHeader {\n  margin-bottom: 18px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #edf2f7;\n}\n\n.utCreateWizard__scoringSectionHeader > span {\n  display: block;\n  margin-bottom: 4px;\n  color: #718096;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.utCreateWizard__scoringSectionHeader h3 {\n  margin: 0;\n  color: #243b53;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.utCreateWizard__scoringSectionHeader p {\n  max-width: 760px;\n  margin: 5px 0 0;\n  color: #62748a;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.utCreateWizard__scoringSection .row {\n  margin-bottom: -16px;\n}\n\n.utCreateWizard__teamScoreComposition {\n  height: calc(100% - 16px);\n  padding: 16px;\n  border: 1px solid #e4eaf0;\n  border-radius: 11px;\n  background: #f8fafc;\n}\n\n.utCreateWizard__teamScoreTable {\n  overflow: hidden;\n  margin-top: 14px;\n  border: 1px solid #dde5ed;\n  border-radius: 9px;\n  background: #fff;\n}\n\n.utCreateWizard__teamScoreTableHead,\n.utCreateWizard__teamScoreTableRow {\n  display: grid;\n  grid-template-columns: minmax(92px, 1fr) 88px 88px;\n  gap: 10px;\n  align-items: center;\n  padding: 9px 12px;\n}\n\n.utCreateWizard__teamScoreTableHead {\n  color: #718096;\n  background: #f4f7fa;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.utCreateWizard__teamScoreTableHead span:not(:first-child) {\n  text-align: center;\n}\n\n.utCreateWizard__teamScoreTableRow + .utCreateWizard__teamScoreTableRow {\n  border-top: 1px solid #edf2f7;\n}\n\n.utCreateWizard__teamScoreTableRow strong {\n  color: #334e68;\n  font-size: 13px;\n}\n\n.utCreateWizard__teamScoreTableRow .form-control {\n  height: 38px;\n  padding: 6px 8px;\n  text-align: center;\n}\n\n@media (max-width: 575px) {\n  .utCreateWizard__scoringSection {\n    padding: 16px;\n  }\n\n  .utCreateWizard__teamScoreTableHead,\n  .utCreateWizard__teamScoreTableRow {\n    grid-template-columns: minmax(70px, 1fr) 72px 72px;\n    gap: 7px;\n    padding-right: 9px;\n    padding-left: 9px;\n  }\n}\n\n.utCreateWizard__netballRule {\n  display: flex;\n  margin-top: 10px;\n  padding: 10px 12px;\n  border: 1px solid #e1e7ed;\n  border-radius: 9px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.utCreateWizard__netballRule > span {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.utCreateWizard__netballRule b {\n  color: #263f57;\n  font-size: 12.5px;\n}\n\n.utCreateWizard__netballRule small {\n  color: #6b7e91;\n  line-height: 1.4;\n}\n\n.utCreateWizard .sit-switch {\n  min-height: 22px;\n  margin: 0;\n  padding: 0;\n  align-items: center;\n}\n\n.utCreateWizard .sit-switch__track {\n  box-sizing: border-box;\n  margin: 0;\n}\n\n.utCreateWizard__settingRow {\n  display: flex;\n  margin-bottom: 16px;\n  padding: 12px 14px;\n  border: 1px solid #dde5ec;\n  border-radius: 10px;\n  background: #fff;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n}\n\n.utCreateWizard__settingRow > span {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.utCreateWizard__settingRow b {\n  color: #263f57;\n  font-size: 13px;\n}\n\n.utCreateWizard__settingRow small {\n  color: #6b7e91;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.utCreateWizard__compactField {\n  max-width: 220px;\n}\n\n.utCreateWizard__fieldHelp {\n  width: min(520px, calc(100vw - 48px));\n  margin: -2px 0 8px;\n  color: #6b7e91;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.utCreateWizard__adminPickerRow {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: start;\n  gap: 10px;\n}\n\n.utCreateWizard__clearAdmins {\n  height: 40px;\n  padding: 0 14px;\n  border: 1px solid #cfd9e3;\n  border-radius: 8px;\n  background: #fff;\n  color: #526579;\n  font-size: 12.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.utCreateWizard__clearAdmins:hover {\n  border-color: #b9c7d4;\n  background: #f6f8fa;\n  color: #253f57;\n}\n\n.utCreateWizard__coverUpload {\n  width: 100%;\n}\n\n.utCreateWizard__coverGrid {\n  display: grid;\n  width: 100%;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.utCreateWizard__coverGrid article {\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #d5e0e8;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.utCreateWizard__coverGrid article > img {\n  display: block;\n  width: 100%;\n  aspect-ratio: 3 / 1;\n  object-fit: cover;\n}\n\n.utCreateWizard__coverGrid article > strong {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: rgba(23, 111, 167, 0.92);\n  color: #fff;\n  font-size: 9px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.utCreateWizard__coverGrid article footer {\n  display: flex;\n  padding: 7px 8px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 5px;\n}\n\n.utCreateWizard__coverGrid article footer button,\n.utCreateWizard__cropModal footer button {\n  height: 30px;\n  margin: 0;\n  padding: 0 9px;\n  border: 1px solid #cbd7e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #395169;\n  cursor: pointer;\n  font-size: 11.5px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.utCreateWizard__coverGrid article footer button:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.utCreateWizard__coverAdd {\n  display: flex;\n  min-height: 150px;\n  margin: 0;\n  border: 1px dashed #afc2d1;\n  border-radius: 10px;\n  background: #f7fafc;\n  color: #277aaa;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 2px;\n  text-align: center;\n}\n\n.utCreateWizard__coverAdd > span {\n  display: flex;\n  width: 32px;\n  height: 32px;\n  margin-bottom: 3px;\n  border-radius: 50%;\n  background: #e5f2fa;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: 400;\n}\n\n.utCreateWizard__coverAdd b {\n  font-size: 12.5px;\n}\n.utCreateWizard__coverAdd small {\n  color: #788a9b;\n  font-size: 11px;\n  font-weight: 400;\n}\n\n.utCreateWizard__coverUpload > p {\n  margin: 9px 0 0;\n  color: #718396;\n  font-size: 11.5px;\n  text-align: center;\n}\n\n.utCreateWizard__coverUpload input {\n  display: none;\n}\n\n@media (max-width: 720px) {\n  .utCreateWizard__coverGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.utCreateWizard__cropModal img {\n  max-height: 58vh;\n}\n\n.utCreateWizard__cropModal footer {\n  display: flex;\n  margin-top: 16px;\n  justify-content: flex-end;\n  gap: 9px;\n}\n\n.utCreateWizard__cropModal footer button {\n  height: 38px;\n  padding: 0 13px;\n  font-size: 12.5px;\n}\n\n.utCreateWizard__cropModal footer button.is-primary {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.utCreateWizard__tagPicker {\n  display: flex;\n  padding: 4px 0;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.utCreateWizard__tagPicker button {\n  min-height: 32px;\n  padding: 0 12px;\n  border: 1px solid color-mix(in srgb, var(--tag-colour) 42%, #d7e0e8);\n  border-radius: 999px;\n  background: #fff;\n  color: #496075;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.utCreateWizard__tagPicker button em {\n  margin-left: 7px;\n  padding: 2px 6px;\n  border-radius: 999px;\n  background: var(--tag-colour);\n  color: #fff;\n  font-size: 9px;\n  font-style: normal;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n\n.utCreateWizard__tagPicker button.is-selected {\n  border-color: var(--tag-colour);\n  background: color-mix(in srgb, var(--tag-colour) 12%, #fff);\n  color: #20384e;\n  box-shadow: inset 0 0 0 1px var(--tag-colour);\n}\n\n.utCreateWizard__createTag {\n  min-height: 32px;\n  margin-top: 8px;\n  padding: 0 11px;\n  border: 1px solid #cbd8e2;\n  border-radius: 7px;\n  background: #fff;\n  color: #227ebd;\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.utCreateWizard__tagModal {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.utCreateWizard__tagModal label {\n  display: flex;\n  margin: 0;\n  color: #40566b;\n  flex-direction: column;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.utCreateWizard__tagModal input:not([type='color']),\n.utCreateWizard__tagModal textarea {\n  width: 100%;\n  padding: 9px 10px;\n  border: 1px solid #ccd7e1;\n  border-radius: 8px;\n  font: inherit;\n}\n.utCreateWizard__tagModal label.is-colour {\n  width: 90px;\n}\n.utCreateWizard__tagModal input[type='color'] {\n  width: 54px;\n  height: 34px;\n  padding: 2px;\n  border: 1px solid #ccd7e1;\n  border-radius: 7px;\n  background: #fff;\n}\n.utCreateWizard__tagModal footer {\n  display: flex;\n  margin-top: 4px;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.utCreateWizard__tagModal footer button {\n  min-height: 36px;\n  padding: 0 13px;\n  border: 1px solid #ccd7e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #50657a;\n  font-weight: 700;\n}\n.utCreateWizard__tagModal footer button.is-primary {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.utCreateWizard__addOptional {\n  min-height: 38px;\n  padding: 0 15px;\n  border: 1px solid #227ebd;\n  border-radius: 8px;\n  background: #fff;\n  color: #227ebd;\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.utCreateWizard__optionalEmpty {\n  margin-bottom: 14px;\n  padding: 22px;\n  border: 1px dashed #cad6e0;\n  border-radius: 10px;\n  background: #f8fafb;\n  color: #75869a;\n  text-align: center;\n  font-size: 12.5px;\n}\n\n.utCreateWizard__optionalCard {\n  display: flex;\n  margin-bottom: 9px;\n  padding: 11px 13px;\n  border: 1px solid #dce4eb;\n  border-radius: 9px;\n  background: #fff;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n}\n\n.utCreateWizard__optionalCard > span {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n}\n\n.utCreateWizard__optionalCardPreview {\n  display: flex;\n  min-width: 0;\n  min-height: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  background: transparent !important;\n  color: inherit !important;\n  flex: 1 1 auto;\n  align-items: flex-start;\n  flex-direction: column;\n  text-align: left;\n}\n\n.utCreateWizard__optionalCard b {\n  color: #294158;\n  font-size: 13px;\n}\n.utCreateWizard__optionalCard small {\n  overflow: hidden;\n  color: #74869a;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.utCreateWizard__optionalCard > div {\n  display: flex;\n  gap: 5px;\n}\n.utCreateWizard__optionalCard button,\n.utCreateWizard__optionalModalFooter button {\n  min-height: 32px;\n  padding: 0 10px;\n  border: 1px solid #d1dbe4;\n  border-radius: 7px;\n  background: #fff;\n  color: #52677b;\n  font-size: 12px;\n  font-weight: 700;\n}\n.utCreateWizard__optionalCard button:disabled {\n  opacity: 0.35;\n}\n\n.utCreateWizard__optionalModalFooter {\n  display: flex;\n  margin-top: 16px;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.utCreateWizard__optionalModalFooter button.is-primary {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.utCreateWizard__customSectionModal,\n.utCreateWizard__customSectionModal .modal-content,\n.utCreateWizard__customSectionModal .modal-body {\n  max-height: none !important;\n}\n\n.utCreateWizard__customSectionModal .modal-body {\n  overflow: visible !important;\n}\n\n.utCreateWizard__sectionPreview time {\n  display: block;\n  margin-bottom: 10px;\n  color: #6c7f92;\n  font-size: 12px;\n  font-weight: 700;\n}\n.utCreateWizard__sectionPreview > img {\n  width: 100%;\n  max-height: 280px;\n  margin-bottom: 14px;\n  border-radius: 10px;\n  object-fit: cover;\n}\n.utCreateWizard__sectionPreview > div {\n  color: #334b61;\n  line-height: 1.6;\n}\n\n.utCreateWizard__optionalSettings {\n  max-width: 620px;\n  margin: -7px 0 18px;\n  padding: 14px;\n  border: 1px solid #e0e7ed;\n  border-radius: 10px;\n  background: #f8fafb;\n}\n\n.utCreateWizard__optionalSettings .form-control,\n.utCreateWizard__optionalSettings .mFullWidth {\n  max-width: 360px;\n}\n\n@media (max-width: 1217px) {\n  .bGenericView--union .bGenericContentColumn > .utCreateWizardPage {\n    margin-top: -16px !important;\n  }\n\n  .utCreateWizard__context {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n}\n\n@media (max-width: 760px) {\n  .utCreateWizard {\n    width: 100%;\n    margin-top: 0;\n  }\n\n  .utCreateWizard__steps {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .utCreateWizard__steps button:nth-child(2) {\n    border-right: 0;\n  }\n\n  .utCreateWizard__steps button:nth-child(-n + 2) {\n    border-bottom: 1px solid #e6ebf0;\n  }\n\n  .utCreateWizard .bTournamentFormBlock {\n    padding: 17px 15px;\n  }\n\n  .utCreateWizard__contextStatus,\n  .utCreateWizard__contextDirty,\n  .utCreateWizard__contextStep {\n    display: none;\n  }\n\n  .utCreateWizard__card {\n    grid-template-columns: 1fr;\n  }\n\n  .utCreateWizard__rail {\n    overflow-x: auto;\n    padding: 12px;\n    border-right: 0;\n    border-bottom: 1px solid #e1e7ed;\n    border-radius: 14px 14px 0 0;\n  }\n\n  .utCreateWizard__railSteps {\n    width: max-content;\n    flex-direction: row;\n    gap: 15px;\n  }\n\n  .utCreateWizard__railSteps button {\n    width: 160px;\n    min-height: 42px;\n    padding: 0;\n  }\n\n  .utCreateWizard__railSteps button::after {\n    display: none;\n  }\n\n  .utCreateWizard__content {\n    padding: 17px 15px 0;\n  }\n\n  .utCreateWizard__footer {\n    margin-right: -15px;\n    margin-left: -15px;\n    padding-right: 15px;\n    padding-left: 15px;\n    border-radius: 0 0 12px 12px;\n  }\n\n  .utCreateWizard__footerContext {\n    display: none;\n  }\n\n  .utCreateWizard__sectionTitle {\n    align-items: flex-start;\n    flex-wrap: wrap;\n    gap: 6px 9px;\n  }\n\n  .utCreateWizard__sectionTitle h2 {\n    white-space: normal;\n  }\n\n  .utCreateWizard__sectionTitle p {\n    width: 100%;\n    margin-left: 0;\n    text-align: left;\n  }\n\n  .utCreateWizard__review {\n    grid-template-columns: 1fr;\n  }\n\n  .utCreateWizard__dateTimeFields {\n    grid-template-columns: 1fr;\n  }\n\n  .utCreateWizard__teamScoring {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .utCreateWizard .utCreateWizard__ageChips {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .utCreateWizard__ageStages {\n    grid-template-columns: 1fr;\n  }\n\n  .utCreateWizard__venueCard > header {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .utCreateWizard__venueCard > header button {\n    justify-content: center;\n  }\n}\n.bTournamentSportMode {\n  display: inline-flex;\n  margin: 0 0 10px;\n  padding: 3px;\n  border: 1px solid #d9e4ec;\n  border-radius: 999px;\n  background: #f4f8fb;\n}\n\n.bTournamentSportMode button {\n  min-height: 28px;\n  padding: 0 12px;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: #5f7182;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.bTournamentSportMode button.active {\n  background: #fff;\n  color: #1797b2;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);\n}\n\n.utCreateWizard__participantLimits {\n  display: grid;\n  gap: 14px;\n  margin: 6px 0 18px;\n  padding: 16px;\n  border: 1px solid #dce6ee;\n  border-radius: 12px;\n  background: #f8fbfd;\n}\n\n.utCreateWizard__participantLimitsHeader strong,\n.utCreateWizard__participantLimitsHeader small {\n  display: block;\n}\n\n.utCreateWizard__participantLimitsHeader strong {\n  color: #1e2d41;\n  font-size: 14px;\n  font-weight: 750;\n}\n\n.utCreateWizard__participantLimitsHeader small {\n  margin-top: 3px;\n  color: #748195;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.utCreateWizard__participantLimits .utCreateWizard__settingRow {\n  margin: 0;\n  padding: 12px 0;\n  border-top: 1px solid #e2e8f0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.utCreateWizard__participantLimitGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.utCreateWizard__participantLimitGrid .form-group {\n  margin: 0;\n}\n\n@media (max-width: 760px) {\n  .utCreateWizard__participantLimitGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
